import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { HEADLINE_METRICS } from "../../lib/metricDefinitions";

// Tap/click "About …" bubble stating what a metric counts, which statuses are
// included/excluded and its date range. Pass metricKey to use the registry
// (preferred) or legacy label/definition/range props.
export const MetricInfo = ({ metricKey, label, definition, counts, included, excluded, range, className = "" }) => {
  const reg = (metricKey && HEADLINE_METRICS[metricKey]) || {};
  const l = label || reg.label || "";
  const desc = definition || reg.description || "";
  const cnt = counts || reg.counts;
  const inc = included || reg.included;
  const exc = excluded || reg.excluded;
  const rng = range || reg.range || "All time";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`About ${l}`}
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex align-middle text-muted-foreground/50 hover:text-primary transition-colors ${className}`}
          data-testid={`metric-info-${(l || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" className="max-w-xs w-72 text-xs space-y-1.5 p-3" onClick={(e) => e.stopPropagation()}>
        <p className="font-semibold text-sm">{l}</p>
        {desc && <p className="text-muted-foreground leading-relaxed">{desc}</p>}
        <div className="pt-1.5 border-t space-y-0.5 text-[11px] leading-relaxed">
          {cnt && <p><span className="font-medium">Counts:</span> {cnt}</p>}
          {inc && <p><span className="font-medium">Included:</span> {inc}</p>}
          {exc && <p><span className="font-medium">Excluded:</span> {exc}</p>}
          <p><span className="font-medium">Range:</span> {rng}</p>
        </div>
      </PopoverContent>
    </Popover>
  );
};
